import { createLog, LogSeverity } from '../../../utils/createLog.js';
import { registerServiceProvider } from '../ServiceProviderRegistry.js';
import { Services } from './Services.js';
import { PayableServicesProvider } from './ServicesProviderPayable.js';
import { servicesProviderPickupDataSchema } from './ServicesProviderPickupData.js';

class ServicesProviderPickup extends PayableServicesProvider {
    constructor(data) {
        super(data);
        this.validateData(data);
        this.physicalAddress = data.physicalAddress;
        this.support = data.support;
    }
    validateData(data) {
        const result = servicesProviderPickupDataSchema.safeParse(data);
        if (!result.success) {
            createLog('ServicesProviderPickup.validation', `ServicesProviderPickup data validation failed for svp id ${data.id}: ${result.error.message}`, LogSeverity.ERROR, {
                service: Services.PICKUP,
                errors: result.error.errors,
            });
            // TODO: change to throw error once db is cleaned up
            return data;
        }
        return result.data;
    }
}
// Register this subclass with ServicesProvider
registerServiceProvider(Services.PICKUP, ServicesProviderPickup);

export { ServicesProviderPickup };
//# sourceMappingURL=ServicesProviderPickup.js.map
